import { Link } from '@material-ui/core';
import React from 'react';

import { Font, FontProps } from '@/components/shared/components/Font';
import { formatSnakeCaseToSpaces } from '@/utils/formatSnakeCaseToSpaces';

export interface TextValueProps {
  tId: string;
  lowerCased?: boolean;
  upperCased?: boolean;
  dynamicDataTexts?: string[];
  capitalized?: boolean;
  trueResult?: boolean;
  originalTextId?: boolean;
  typography?: FontProps;
  strong?: boolean;
  small?: boolean;
  translation?: string | undefined;
  linkCallbacks?: (() => void)[];
  linkStyle?: React.CSSProperties;
  linkSeparator?: string;
}

export const TextValue = (props: TextValueProps): JSX.Element | null => {
  const {
    tId,
    lowerCased,
    upperCased,
    dynamicDataTexts,
    capitalized,
    trueResult,
    originalTextId,
    typography,
    strong,
    small,
    translation,
    linkCallbacks = [],
    linkStyle = {},
    linkSeparator = '**LINK**',
  } = props;

  if (!translation && trueResult) {
    return null;
  }
  if (!translation && originalTextId) {
    return <>{tId}</>;
  }
  let result: string | React.ReactElement = translation || tId || '';

  if (!result) return null;

  if (upperCased && typeof result === 'string') result = formatSnakeCaseToSpaces(result).toUpperCase();
  if ((lowerCased || (!translation && tId)) && typeof result === 'string')
    result = formatSnakeCaseToSpaces(result).toLowerCase();
  if ((capitalized || (!translation && tId)) && typeof result === 'string')
    result = result.charAt(0).toUpperCase() + result.slice(1);

  if (dynamicDataTexts && typeof result === 'string' && result.includes('$v')) {
    const dynamicDataTextsArray = Array.isArray(dynamicDataTexts) ? dynamicDataTexts : [dynamicDataTexts];
    for (let i = 0; i <= dynamicDataTextsArray.length - 1; i += 1) {
      result = result.replace(`$v${i + 1}`, dynamicDataTextsArray[i]);
    }
  }

  const addLinks = () => {
    if (typeof result !== 'string') return;
    const splitTextAndLinksArray = result.split(linkSeparator);
    const isOdd = (num: number) => num % 2;
    result = (
      <>
        {splitTextAndLinksArray.map((textOrLink, num) => {
          if (isOdd(num)) {
            const linkNum = (num - 1) / 2;
            const clickCallback = linkCallbacks[linkNum];
            return (
              <Link
                key={num}
                href="#"
                onClick={(event) => {
                  event.preventDefault();
                  clickCallback?.();
                }}
                onKeyDown={(event) => {
                  if (event.key === ' ' || event.key === 'Enter') {
                    event.preventDefault();
                    clickCallback?.();
                  }
                }}
                style={{ cursor: 'pointer', ...linkStyle }}
              >
                {textOrLink}
              </Link>
            );
          } else {
            return textOrLink;
          }
        })}
      </>
    );
  };

  if (typeof result === 'string') {
    addLinks();
  }

  if (strong) result = <strong>{result}</strong>;
  if (small) result = <small>{result}</small>;

  const fontOptions = typography;
  if (fontOptions) {
    result = <Font {...fontOptions}>{result}</Font>;
  }

  return typeof result === 'string' ? <>{result}</> : result;
};
